import { coefficients, nutrientsDemand, prices } from "./coefficients";

// let prices = store.store.getState().app?.prices || [];

export const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substring(0, j) + thousands : '') + i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
    return '0'
  }
};

export const formatDate = (date) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + (d.getDate() + 1);
  let year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;

  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

const getMonths = (currentYear = "2021") => {
  return [
    `jan/${currentYear}`,
    `fev/${currentYear}`,
    `mar/${currentYear}`,
    `abr/${currentYear}`,
    `mai/${currentYear}`,
    `jun/${currentYear}`,
    `jul/${currentYear}`,
    `ago/${currentYear}`,
    `set/${currentYear}`,
    `out/${currentYear}`,
    `nov/${currentYear}`,
    `dez/${currentYear}`
  ]
}

export const getFertilizerPrices = (animalsQuantity, productionSystem, recommendedVolume) => {
  if (!prices || !prices.length) {
    prices = store.store.getState().app?.prices || [];
  }

  const months = getMonths();
  let nutrientsType = ['N', 'P2O5', 'K2O'];

  const chemicals = {
    "Ureia": prices.filter(item => item["Trimestre"].includes("Ureia"))[0],
    "SuperfosfatoTriplo": prices.filter(item => item["Trimestre"].includes("Superfosfato Triplo"))[0],
    "CloretoPotássio": prices.filter(item => item["Trimestre"].includes("Cloreto Potássio"))[0],
  }

  const offer = nutrientsType.map(nutrient => ({ nutrient, value: getOffer(nutrient, animalsQuantity, productionSystem) }))

  let fertilizingValueMonths = {};

  months.map(month => {
    fertilizingValueMonths[month] = chemicals["Ureia"][month] / 50 * offer[0].value / 0.45;
    fertilizingValueMonths[month] += chemicals["SuperfosfatoTriplo"][month] / 50 * offer[1].value / 0.42;
    fertilizingValueMonths[month] += chemicals["CloretoPotássio"][month] / 50 * offer[2].value / 0.6;
    fertilizingValueMonths[month] /= recommendedVolume;

    fertilizingValueMonths[month] = parseFloat(fertilizingValueMonths[month].toFixed(2));
  });

  return fertilizingValueMonths;
}

export const getFertilizerValue = (currentApplication, areas = [], animalsQuantity, productionSystem, recommendedVolume, selectedYear) => {
  const fertilizerPrices = getFertilizerPrices(
    animalsQuantity,
    productionSystem,
    recommendedVolume
  );

  let result = 0;

  const equipmentValue = prices.filter(price => price["Trimestre"]?.toLocaleLowerCase() === currentApplication?.equipment.split("|")[0].toLocaleLowerCase())[0] || {} // equipment value
  const monthPrice = fertilizerPrices[currentApplication.month] || 0; // Valor Fertilizante
  const equipmentPrice = equipmentValue[currentApplication.month] || 0;

  areas.map(area => {
    const yearApplications = area?.applications ? area?.applications.filter(application => application?.applicationYear == selectedYear) : [];
    let volumeApplication = 0;

    const currentApplicationIndex = yearApplications.findIndex(item => item?.id === currentApplication?.id);

    if (currentApplicationIndex === -1) return;

    yearApplications.slice(currentApplicationIndex).map(application => {
      const volume = application?.values?.filter(value => value?.question === 'Informe o volume aplicado')[0]?.value || 0;
      volumeApplication += parseInt(volume, 10) || 0;
    })

    if (volumeApplication > area?.volumeRecomendation) {
      result += 0;
    } else {
      const isOtherArea = area?.values?.filter(value => value?.question === 'Área de terceiros')[0]?.value || false;
      result = (Number(currentApplication.value) * (isOtherArea ? 0 : 1));
    }
  })

  return {
    fertilizerPrice: (result * monthPrice).toFixed(2) || 0,
    equipmentPrice: (equipmentPrice * parseInt(currentApplication.hours, 10)).toFixed(2) || 0
  };
}

export const getFertilizerByApplications = (areas, animalsQuantity, productionSystem, recommendedVolume, selectedYear) => {
  const months = getMonths();
  let totalNetBenefit = 0;
  

  console.log({
    areas,
    animalsQuantity,
    productionSystem,
    recommendedVolume,
    selectedYear
  })

  areas = areas.map(area => {
    const yearApplications = area?.applications ? area?.applications.filter(application => application?.applicationYear == selectedYear) : [];
    if (yearApplications) {
      let applications = yearApplications.map(item => ({ ...item, date: new Date(item?.date) })) || [];
      applications = applications.sort((a, b) => Number(a?.date || 0) - Number(b?.date || 0));
      applications = applications.map(item => ({ ...item, date: formatDate(item.date) }));

      applications = applications.map(application => {
        let currentDateApplication = 'jan/2021';
        let lastApplication = 'jan/2021';

        if (application?.date) {
          if (application?.date.split('-')[1] == 12) {
            lastApplication = months[0];
            currentDateApplication = months[0];
          } else {
            lastApplication = months[parseInt(application?.date.split('-')[1] || 0, 10) - 2] || currentDateApplication;
            currentDateApplication = months[parseInt(application?.date.split('-')[1] || 0, 10) - 1] || currentDateApplication;
          }
        }

        const currentApplication = {
          id: application?.id,
          value: Number(application?.volumeApplied) || 0,
          lastMonth: lastApplication,
          month: currentDateApplication,
          hours: Number(application?.applicationTime) || 1,
          equipment: application.equipmentType || '',
        }

        const values = getFertilizerValue(
          currentApplication,
          areas,
          animalsQuantity,
          productionSystem,
          recommendedVolume,
          selectedYear
        );

        totalNetBenefit += (values?.fertilizerPrice - values?.equipmentPrice) || 0;

        return {
          ...application,
          fertilizerValue: values?.fertilizerPrice || 0,
          equipmentPrice: values?.equipmentPrice,
          netBenefit: (values?.fertilizerPrice - values?.equipmentPrice).toFixed(2) || 0
        }
      })

      return {
        ...area,
        applications,
        totalNetBenefit
      }
    }
    return {
      ...area,
      totalNetBenefit
    };
  })

  return [...areas];
}

export const getAreasDetails = (areas = [], animalsQuantity = 0, productionSystem = 'UT', waterConsumption = 'low', selectedYear) => {
  let nutrientsType = ['N', 'P2O5', 'K2O'];
  areas = areas.map(area => {
    let nutrientArea = nutrientsType.map(nutrient => {
      const yearCultures = area.cultures ? area.cultures.filter(culture => culture?.plantingYear == selectedYear) : [];
      const yearApplications = area?.applications ? area?.applications.filter(application => application?.applicationYear == selectedYear) : [];
      return {
        title: nutrient,
        offer: getOffer(nutrient, animalsQuantity, productionSystem),
        applicatedNutrient: getApplicatedNutrient(
          nutrient,
          animalsQuantity,
          getVolumeAreas(yearApplications || []),
          getAnnualVolume(
            animalsQuantity,
            productionSystem,
            waterConsumption
          ),
          productionSystem
        ),
        demand: getNutrientDemand(yearCultures, nutrient, parseInt(area?.ha, 10))
      }
    })

    return {
      ...area,
      nutrientArea: {
        "N": nutrientArea[0],
        "P2O5": nutrientArea[1],
        "K2O": nutrientArea[2]
      }
    };
  })

  return Array.from(areas);
}

export const getNutrientDemand = (cultures = [], nutrientType = 'N', ha = 0) => {
  let totalDemand = 0;

  for (const culture of cultures) {
    const cultureName = culture?.culture; // question: 'Informe a cultura'
    let expectationHarvest = culture?.productionExpectation || 0;

    if (!cultureName || !expectationHarvest || parseInt(expectationHarvest, 10) < 1) {
      totalDemand += 0;
    } else {
      const nutrientsDemandDetails = nutrientsDemand.filter(nutrient => nutrient["Cultura"].toLocaleLowerCase() === cultureName.toLocaleLowerCase())[0];

      if (!nutrientsDemandDetails) {
        totalDemand += 0;
      } else if (!nutrientsDemandDetails["Produtiv_min"] || parseInt(expectationHarvest, 10) < nutrientsDemandDetails["Produtiv_min"]) {
        totalDemand += 0;
      } else {
        if (parseInt(expectationHarvest, 10) > nutrientsDemandDetails["Produtiv_max"]) {
          totalDemand += (
            nutrientsDemandDetails[`${nutrientType}_min`] +
            (nutrientsDemandDetails["Produtiv_max"] - nutrientsDemandDetails["Produtiv_min"]) *
            nutrientsDemandDetails[`${nutrientType}_adic`]
          )
        } else {
          totalDemand += (
            nutrientsDemandDetails[`${nutrientType}_min`] +
            (parseInt(expectationHarvest, 10) - nutrientsDemandDetails["Produtiv_min"]) *
            nutrientsDemandDetails[`${nutrientType}_adic`]
          )
        }
      }
    }
  }

  return (totalDemand * ha) || 0;
}

export const getOffer = (nutrientType = 'N', animalsQuantity = 0, productionSystem = 'UT') => {
  const aviableNutrient = coefficients[productionSystem] ? coefficients[productionSystem][nutrientType] : 0;
  const offer = aviableNutrient * animalsQuantity;

  return offer || 1;
}

export const getApplicatedNutrient = (nutrientType = 'N', animalsQuantity = 0, areaApplication = 0, recommendedVolume = 0, productionSystem = 'UT') => {
  if (!areaApplication || !animalsQuantity) {
    return 0
  }

  const offer = getOffer(nutrientType, animalsQuantity, productionSystem);

  const applicatedValue = Math.round((offer / recommendedVolume) * areaApplication);

  return applicatedValue;
}

export const getVolumeAreas = (applications = []) => {
  if(!applications || !applications.length) {
    return 0;
  }

  const volume = applications
    .filter(item => item && item?.volumeApplied)
    .map(application => Number(application.volumeApplied));

  let total = 0;

  for (let i = 0; i < volume.length; i++) {
    if (volume[i]) {
      total += parseInt(volume[i], 10);
    }
  }

  return parseFloat(total.toFixed(2)) || 0;
}

export const getWaterConsumptionLevel = (productionSystem = 'UT') => {
  const formula = (coefficients[productionSystem].waterConsumption);

  return {
    low: formula * coefficients.waterConsumption.low,
    average: formula * coefficients.waterConsumption.average,
    height: formula * coefficients.waterConsumption.height,
  }
}

export const getAnnualVolume = (animalsQuantity = 1, productionSystem = 'UT', waterConsumptionType = 'average') => {
  if (!coefficients[productionSystem]) {
    productionSystem = 'UT';
  }

  const formula = coefficients[productionSystem]?.wasteExcretion * coefficients.waterConsumption[waterConsumptionType];

  const result = formula * animalsQuantity;

  return parseFloat(result.toFixed(2));
}